<div class="dashboard-container">
  <div class="dashboard-header">
    <h1>{{ titleText }}</h1>
  </div>

  <div class="tabs">
    <button
      class="tab-button"
      [class.active]="activeTab === 'supplies'"
      (click)="switchTab('supplies')"
      type="button"
    >
      {{ suppliesTabText }}
    </button>
    <button
      class="tab-button"
      [class.active]="activeTab === 'requests'"
      (click)="switchTab('requests')"
      type="button"
    >
      {{ requestsTabText }}
    </button>
    <button
      class="tab-button"
      [class.active]="activeTab === 'deals'"
      (click)="switchTab('deals')"
      type="button"
    >
      {{ dealsTabText }}
    </button>
    <button
      class="tab-button"
      [class.active]="activeTab === 'calculations'"
      (click)="switchTab('calculations')"
      type="button"
    >
      {{ calculationsTabText }}
    </button>
    <button
      class="tab-button"
      [class.active]="activeTab === 'settings'"
      (click)="switchTab('settings')"
      type="button"
    >
      {{ settingsTabText }}
    </button>
  </div>

  <div class="dashboard-content">
    <!-- Requests Tab -->
    <div *ngIf="activeTab === 'requests'">
      <div *ngIf="loadingRequests" class="loading">
        {{ loadingText }}
      </div>

      <div *ngIf="errorRequests" class="error">
        {{ errorRequests }}
      </div>

      <div *ngIf="!loadingRequests && !errorRequests && requests.length === 0" class="empty-state">
        <p>{{ noRequestsText }}</p>
      </div>

      <div *ngIf="!loadingRequests && !errorRequests && requests.length > 0" class="requests-table">
        <table>
          <thead>
            <tr>
              <th>{{ requestNumberText }}</th>
              <th>{{ companyNameText }}</th>
              <th>{{ forwarderText }}</th>
              <th>{{ routeText }}</th>
              <th>{{ totalWeightText }}</th>
              <th>{{ totalVolumeText }}</th>
              <th>{{ calculationStatusText }}</th>
              <th>{{ createdAtText }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let request of requests" class="clickable-row">
              <td>{{ request.id | docNo:'R':request.createdAt }}</td>
              <td>{{ request.cargoOwnerCompanyName || '-' }}</td>
              <td>{{ request.freightForwarderCompanyName || '-' }}</td>
              <td>{{ getRoute(request) }}</td>
              <td>{{ formatWeight(getTotalWeight(request)) }}</td>
              <td>{{ formatVolume(getTotalVolume(request)) }}</td>
              <td>
                <span class="status-badge" [class.completed]="request.customsCalculationCompleted" [class.in-progress]="request.customsCalculationStarted && !request.customsCalculationCompleted">
                  {{ getCalculationStatus(request) }}
                </span>
              </td>
              <td>{{ request.createdAt | date:'short' }}</td>
              <td>
                <button (click)="viewRequest(request.id)" class="btn btn-primary btn-sm">
                  {{ viewText }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <app-pagination
          *ngIf="requestsPage"
          [number]="requestsPage.number"
          [totalPages]="requestsPage.totalPages"
          [size]="requestsPage.size"
          [totalElements]="requestsPage.totalElements"
          [hasNext]="requestsPage.hasNext"
          [hasPrevious]="requestsPage.hasPrevious"
          (pageChange)="onRequestsPageChange($event)"
        ></app-pagination>
      </div>
    </div>

    <!-- Deals Tab -->
    <div *ngIf="activeTab === 'deals'">
      <div *ngIf="loadingDeals" class="loading">
        {{ loadingText }}
      </div>

      <div *ngIf="errorDeals" class="error">
        {{ errorDeals }}
      </div>

      <div *ngIf="!loadingDeals && !errorDeals && deals.length === 0" class="empty-state">
        <p>{{ noDealsText }}</p>
      </div>

      <div *ngIf="!loadingDeals && !errorDeals && deals.length > 0" class="requests-table">
        <table>
          <thead>
            <tr>
              <th>{{ dealIdText }}</th>
              <th>{{ cargoOwnerText }}</th>
              <th>{{ forwarderText }}</th>
              <th>{{ statusText }}</th>
              <th>{{ createdAtText }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let deal of deals" class="clickable-row">
              <td>{{ deal.id | docNo:'D':deal.createdAt }}</td>
              <td>{{ deal.cargoOwnerCompanyName || '-' }}</td>
              <td>{{ deal.freightForwarderCompanyName || '-' }}</td>
              <td>
                <span class="status-badge">{{ getDealStatusText(deal.status) }}</span>
              </td>
              <td>{{ deal.createdAt | date:'short' }}</td>
              <td>
                <button (click)="viewDeal(deal.id)" class="btn btn-primary btn-sm">
                  {{ viewText }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <app-pagination
          *ngIf="dealsPage"
          [number]="dealsPage.number"
          [totalPages]="dealsPage.totalPages"
          [size]="dealsPage.size"
          [totalElements]="dealsPage.totalElements"
          [hasNext]="dealsPage.hasNext"
          [hasPrevious]="dealsPage.hasPrevious"
          (pageChange)="onDealsPageChange($event)"
        ></app-pagination>
      </div>
    </div>

    <!-- Calculations Tab -->
    <div *ngIf="activeTab === 'calculations'">
      <app-calculations-list
        [calculations]="calculations"
        [calculationsPage]="calculationsPage"
        [loading]="loadingCalculations"
        [error]="errorCalculations"
        [showCreateButton]="false"
        [showDeleteButton]="false"
        [showOwnerColumn]="true"
        [backRoute]="'/customs-broker/dashboard'"
        (viewCalculation)="onViewCalculation($event)"
        (pageChange)="onCalculationsPageChange($event)"
        (filterChange)="onCalculationsFilterChange($event)"
      ></app-calculations-list>
    </div>

    <!-- Supplies Tab -->
    <div *ngIf="activeTab === 'supplies'">
      <app-supplies-list
        [calculations]="supplies"
        [calculationsPage]="suppliesPage"
        [loading]="loadingSupplies"
        [error]="errorSupplies"
        [title]="suppliesTitleText"
        [subtitle]="suppliesSubtitleText"
        [emptyText]="suppliesEmptyText"
        (viewCalculation)="onOpenSupply($event)"
        (pageChange)="onSuppliesPageChange($event)"
        (filterChange)="onSuppliesFilterChange($event)"
      ></app-supplies-list>
    </div>

    <!-- Settings Tab -->
    <div *ngIf="activeTab === 'settings'" class="settings-tab">
      <div *ngIf="!settingsSection" class="settings-menu">
        <h2>{{ settingsTitleText }}</h2>
        <ul class="settings-list">
          <li>
            <button
              type="button"
              class="settings-link"
              (click)="openSettingsSection('document-types')"
            >
              <span class="settings-link__title">{{ settingsDocumentTypesText }}</span>
              <span class="settings-link__desc">{{ settingsDocumentTypesDescText }}</span>
            </button>
          </li>
        </ul>
      </div>

      <div *ngIf="settingsSection === 'document-types'" class="settings-section">
        <button type="button" class="settings-back" (click)="backToSettingsMenu()">
          ← {{ settingsBackText }}
        </button>
        <app-document-types [embedded]="true"></app-document-types>
      </div>
    </div>
  </div>
</div>
